import script from "./WebinarSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarSection.vue?vue&type=script&setup=true&lang=js"

import "./WebinarSection.vue?vue&type=style&index=0&id=71bc71b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71bc71b0"]])

export default __exports__